<template>
  <div class="main-container">

    <div class="container">
      <div class="column-75 page-middle">
        <h2>ENTER YOUR DATE OF BIRTH</h2>
        <h4>Please enter your date of birth below to continue.</h4>
      </div>
    </div>

    <form @submit.prevent="send_form()"  action="" enctype='application/json' novalidate>
      <date_of_birth v-if="local_config.fields.date_of_birth" v-show="local_config.fields.date_of_birth.show"></date_of_birth>
      <!-- <state :disabled="false" v-if="local_config.fields.state && (default_state == '')" v-show="local_config.fields.state.show"></state> -->
      <br>
      <input type="hidden" v-model="default_sweeps" name="default_sweeps"/>
      <button type="submit" :disabled="$store.state.loader">ENTER</button>
    </form>

  </div>
</template>

<script>
    import {fields, form_methods, requests_methods, validation} from '../mixins/requests'
    import {elements_classes} from '../mixins/elements_classes'

    // FIELDS
    import date_of_birth from '../components/fields/date_of_birth'
    import state from '../components/fields/state'

    export default {
        name: "gate",
        mixins: [fields, form_methods, requests_methods, validation, elements_classes],
        components:{
            date_of_birth, state
        },
        data(){
            return{
              default_state: '',
              default_sweeps: ''
                // this_page: 'gate'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }
        },
        mounted() {
          if(this.$store.getters.default_state){
            this.default_state = this.$store.getters.default_state;
          }
          if(this.$store.getters.default_sweeps){
            this.default_sweeps = this.$store.getters.default_sweeps;
          }
        }
    }
</script>

<style scoped>
</style>